import { useCallback } from 'react';
import { TelemetryClient } from '@jarvis/web-stratus-client';
import { useApiCall, useRootContext } from '@jarvis/react-portal-addons';

export const useSummaryOfAllJobsApiCall = ({ init = true } = {}) => {
  const { shell: { authProvider }, stack } = useRootContext();

  const fetch = useCallback(async () => {
    const client = new TelemetryClient(stack, authProvider);
    const response = await client.getSummaryOfAllJobs({ numDays: 30 });
    return response.data;
  }, [authProvider, stack]);

  return useApiCall({
    apiCall: fetch,
    init,
  });
};

export default useSummaryOfAllJobsApiCall;
